export default{
    tipos: [],
}